import { GeoJsonCollection } from '../expansion/features-buffer-geom-translator';

/**
 * Sentinel value stored in the tile cache to represent a known-empty tile
 * (e.g. a 204 No Content response).  Using a sentinel instead of `null`
 * satisfies the `V extends {}` constraint imposed by node-lru-cache v11.
 */
export const EMPTY_TILE: unique symbol = Symbol('EMPTY_TILE');
export type EmptyTile = typeof EMPTY_TILE;

/**
 * Either a real GeoJSON feature-collection or {@link EMPTY_TILE} for a tile
 * that the server confirmed has no features.  `null` is intentionally avoided
 * here because node-lru-cache v11 disallows nullable value types.
 */
export type FeaturesServiceMeshData = GeoJsonCollection | EmptyTile;
